// App.js
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Navigation from "./components/Navigation";
import TastyBites from "./pages/TastyBites";
import Login from "./pages/Login";
import OrderHistory from "./pages/OrderHistory";
import UserProfile from "./pages/UserProfile";
import OrderDetail from "./pages/OrderDetail";
import "./styles/theme.css";
function App() {
  const [user, setUser] = useState(null);
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("tasty_cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  useEffect(() => {
    localStorage.setItem("tasty_cart", JSON.stringify(cart));
  }, [cart]);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [settings, setSettings] = useState({});
  const [table, setTable] = useState({});
  const [hashcode, setHashcode] = useState(null);
  useEffect(() => {
    const savedUser = localStorage.getItem("user");
    if (savedUser && savedUser !== "undefined") {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem("user");
    localStorage.removeItem("authToken");
  };

  const getTotalItems = () => {
    return cart.reduce((total, item) => total + item.quantity, 0);
  };

  return (
    <Router>
      {/* DARK THEME WRAPPER */}
      <div className="dark-app min-vh-100">
        <Navigation
          user={user}
          onLogout={handleLogout}
          isCartOpen={isCartOpen}
          setIsCartOpen={setIsCartOpen}
          getTotalItems={getTotalItems}
          settings={settings}
          table={table}
          hashcode={hashcode}
        />

        <Routes>
          <Route
            path="/:hashcode"
            element={
              <TastyBites
                cart={cart}
                setCart={setCart}
                isCartOpen={isCartOpen}
                setIsCartOpen={setIsCartOpen}
                settings={settings}
                table={table}
                setSettings={setSettings}
                setTable={setTable}
                setHashcode={setHashcode}
              />
            }
          />

          <Route
            path="/:hashcode/login"
            element={<Login onLogin={handleLogin} />}
          />

          <Route
            path="/:hashcode/orders"
            element={user ? <OrderHistory /> : <Login onLogin={handleLogin} />}
          />

          <Route
            path="/:hashcode/orders/:id"
            element={user ? <OrderDetail /> : <Login onLogin={handleLogin} />}
          />

          <Route
            path="/:hashcode/profile"
            element={user ? <UserProfile /> : <Login onLogin={handleLogin} />}
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
